import CourseCover from 'components/CourseCover'
import {FC} from 'external/react'

type CourseProps = {
    id: string,
    name: string,
    source: 'basic' | 'elective' | 'extra' 
    onCourseClick?: (props: any) => void
}

const Course: FC<CourseProps> = props => {
    const {id, name, onCourseClick, source} = props
    return (
        <div className='containerSelected'>
            <div className='containerSelectedBody package-courses-detail' style={{ position: 'relative' }}>
                <CourseCover id={id} name={name} />
                {onCourseClick && (
                    <button
                        onClick={() => onCourseClick({id, source})}
                        title="Cambiar curso"
                        style={{
                            position: 'absolute',
                            top: 6,
                            right: 6,
                            background: 'rgba(255,255,255,0.85)',
                            border: 'none',
                            borderRadius: '50%',
                            width: 28,
                            height: 28,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            padding: 0,
                            boxShadow: '0 1px 4px rgba(0,0,0,0.2)'
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                        </svg>
                    </button>
                )}
            </div>
            <div className='containerSelectedFooter'>
                <p>{name}</p>
            </div>
        </div>
    )
}

export {Course as default}